var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"ml-1 btn-show rounded-pill",attrs:{"x-small":"","fab":""},on:{"click":function($event){return _vm.action(_vm.data, 'information')}}},[_c('v-icon',[_vm._v("mdi-eye")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }